(() => {
  const CONFIG = {
    sellingPlanId: 1731821745,
    variants: {
      44781724500145: '25 x NY-Style Dough Balls',
      44899279143089: '50 x NY-Style Dough Balls',
      47214343323825: '100 x NY-Style Dough Balls'
    }
  };

  const formatMoney = (cents) => {
    try {
      return new Intl.NumberFormat('en-US', { style: 'currency', currency: window.Shopify?.currency?.active || 'USD' }).format(cents / 100);
    } catch (_) {
      return `$${(cents / 100).toFixed(2)}`;
    }
  };

  const eligibleItems = (cart) => cart.items.filter((item) => {
    return CONFIG.variants[item.variant_id] && !item.selling_plan_allocation;
  });

  const visibleCartLines = () => Array.from(document.querySelectorAll('#cart-drawer ul[role="list"] > li'));

  const iconFire = `
    <svg viewBox="0 0 9 12" fill="none" aria-hidden="true" focusable="false">
      <path d="M4.46 11.46c2.13 0 3.86-1.64 3.86-3.66 0-1.62-.87-2.86-1.86-3.9-.33.82-.82 1.45-1.45 1.88.19-1.77-.58-3.44-2.08-5.1.05 1.86-.65 2.82-1.35 3.78C.91 5.38.25 6.28.25 7.8c0 2.02 1.9 3.66 4.21 3.66Z" fill="currentColor"/>
    </svg>`;

  const icons = {
    dollar: `
      <svg viewBox="0 0 24 24" fill="none" aria-hidden="true" focusable="false">
        <path d="M12 2.25C6.62 2.25 2.25 6.62 2.25 12S6.62 21.75 12 21.75 21.75 17.38 21.75 12 17.38 2.25 12 2.25Zm0 18A8.25 8.25 0 1 1 12 3.75a8.25 8.25 0 0 1 0 16.5Zm3.75-6.38c0 .7-.28 1.37-.77 1.86-.49.49-1.16.77-1.86.77h-.37v.75a.75.75 0 0 1-1.5 0v-.75H9.75a.75.75 0 0 1 0-1.5h3.38a1.13 1.13 0 0 0 0-2.25h-2.25a2.63 2.63 0 0 1 0-5.25h.37v-.75a.75.75 0 0 1 1.5 0v.75h1.5a.75.75 0 0 1 0 1.5h-3.38a1.13 1.13 0 0 0 0 2.25h2.25c.7 0 1.37.28 1.86.77.49.49.77 1.16.77 1.85Z" fill="currentColor"/>
      </svg>`,
    receipt: `
      <svg viewBox="0 0 24 24" fill="none" aria-hidden="true" focusable="false">
        <path d="M20.25 3.75H3.75c-.4 0-.78.16-1.06.44-.28.28-.44.66-.44 1.06V19.5a.75.75 0 0 0 1.09.67L6 18.84l2.66 1.33a.75.75 0 0 0 .68 0L12 18.84l2.66 1.33a.75.75 0 0 0 .68 0L18 18.84l2.66 1.33a.75.75 0 0 0 1.09-.67V5.25c0-.4-.16-.78-.44-1.06a1.5 1.5 0 0 0-1.06-.44Zm0 14.54-1.91-.96a.75.75 0 0 0-.68 0L15 18.66l-2.66-1.33a.75.75 0 0 0-.68 0L9 18.66l-2.66-1.33a.75.75 0 0 0-.68 0l-1.91.96V5.25h16.5v13.04ZM9.22 12.97l1.72-1.72-1.72-1.72a.75.75 0 1 1 1.06-1.06L12 10.19l1.72-1.72a.75.75 0 0 1 1.06 1.06l-1.72 1.72 1.72 1.72a.75.75 0 1 1-1.06 1.06L12 12.31l-1.72 1.72a.75.75 0 0 1-1.06-1.06Z" fill="currentColor"/>
      </svg>`,
    truck: `
      <svg viewBox="0 0 24 24" fill="none" aria-hidden="true" focusable="false">
        <path d="m23.95 10.97-1.32-3.28a1.5 1.5 0 0 0-1.39-.94H18V6a.75.75 0 0 0-.75-.75H3a1.5 1.5 0 0 0-1.5 1.5v10.5A1.5 1.5 0 0 0 3 18.75h1.59a3 3 0 0 0 5.82 0h4.68a3 3 0 0 0 5.82 0h1.59a1.5 1.5 0 0 0 1.5-1.5v-6c0-.1-.02-.19-.05-.28ZM18 8.25h3.24l.9 2.25H18V8.25ZM3 6.75h13.5v6H3v-6Zm4.5 12.75a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3Zm7.59-2.25h-4.68a3 3 0 0 0-5.82 0H3v-3h13.5v1.15a3.02 3.02 0 0 0-1.41 1.85ZM18 19.5a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3Zm4.5-2.25h-1.59A3.01 3.01 0 0 0 18 15v-3h4.5v5.25Z" fill="currentColor"/>
      </svg>`
  };

  const benefit = (icon, text) => `
    <li>
      <span class="pb-subscription-upsell__icon">${icons[icon]}</span>
      <span>${text}</span>
    </li>`;

  const makeCard = (item) => {
    const card = document.createElement('div');
    card.className = 'pb-subscription-upsell';
    card.dataset.pbSubscriptionUpsell = item.key;
    card.innerHTML = `
      <div class="pb-subscription-upsell__header">
        <div class="pb-subscription-upsell__badge">${iconFire}<span>Most Popular</span></div>
        <div class="pb-subscription-upsell__title">Subscribe &amp; Save an Extra 15%</div>
      </div>
      <ul class="pb-subscription-upsell__list" aria-label="Subscription benefits">
        ${benefit('dollar', 'Instantly save 15% on every order')}
        ${benefit('receipt', 'Modify, skip, cancel anytime')}
        ${benefit('truck', 'Free shipping in the US')}
      </ul>
      <button type="button" class="pb-subscription-upsell__button">Upgrade and Save</button>
    `;
    card.querySelector('button').addEventListener('click', () => upgradeItem(item, card));
    return card;
  };

  async function upgradeItem(item, card) {
    if (!item?.key || card?.classList.contains('is-loading')) return;
    card.classList.add('is-loading');
    const button = card.querySelector('button');
    if (button) button.textContent = 'Upgrading...';

    try {
      const response = await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: item.key, quantity: item.quantity, selling_plan: CONFIG.sellingPlanId })
      });

      if (!response.ok) throw new Error(`Cart swap failed: ${response.status}`);
      document.dispatchEvent(new CustomEvent('update-cart'));
    } catch (error) {
      console.error('[Poco Bero] Subscription upsell failed', error);
      card.classList.remove('is-loading');
      if (button) button.textContent = 'Upgrade and Save';
      card.querySelector('.pb-subscription-upsell__fineprint').textContent = 'Could not upgrade automatically. Please try again.';
    }
  }

  let renderTimer;
  async function renderUpsells() {
    clearTimeout(renderTimer);
    renderTimer = setTimeout(async () => {
      const drawer = document.getElementById('cart-drawer');
      if (!drawer) return;

      let cart;
      try {
        cart = await fetch('/cart.js', { headers: { Accept: 'application/json' } }).then((r) => r.json());
      } catch (_) {
        return;
      }

      const eligible = eligibleItems(cart);
      const eligibleKeys = new Set(eligible.map((item) => item.key));
      drawer.querySelectorAll('[data-pb-subscription-upsell]').forEach((node) => {
        if (!eligibleKeys.has(node.dataset.pbSubscriptionUpsell)) node.remove();
      });
      if (!eligible.length) return;

      const renderedItems = cart.items.filter((item) => item.variant_id !== 45077724594353);
      const lines = visibleCartLines();

      eligible.forEach((item) => {
        const visibleIndex = renderedItems.findIndex((candidate) => candidate.key === item.key);
        const line = lines[visibleIndex];
        if (!line || line.querySelector('[data-pb-subscription-upsell]')) return;
        line.appendChild(makeCard(item));
      });
    }, 80);
  }

  document.addEventListener('DOMContentLoaded', renderUpsells);
  document.addEventListener('toggle-cart', renderUpsells);
  document.addEventListener('update-cart', () => setTimeout(renderUpsells, 350));
  document.addEventListener('rebuy:cart.change', renderUpsells);

  const observer = new MutationObserver(() => renderUpsells());
  const startObserver = () => {
    const drawer = document.getElementById('cart-drawer');
    if (drawer) observer.observe(drawer, { childList: true, subtree: true });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', startObserver);
  else startObserver();
})();
